import router from '../router'
import store from '../store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getToken,
  removeToken,
  getInfo,
  filterAsyncRouter,
} from '@/utils/auth' // get token from cookie
import filterRoute from '@/router/router.js';

NProgress.configure({
  showSpinner: true
}) // NProgress Configuration
// removeToken();
const whiteList = ['/login'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start()
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done()
    } else {
      //获取数据，添加到路由表，检索菜单的数据
      let has = false;
      let t = localStorage.getItem('ActiveRouter');
      t = JSON.parse(t);
      if (t) {
        t.forEach(item => {
          if (item.name == to.name || item.path == to.path) {
            has = item;
          }
        });
        if (to.matched.length === 0) {
          if (has) {//过滤有访问权限，追加动态路由
            filterRoute.forEach(it => {
              if (has.name == it.name) {
                has = it;
              }
            });
            router.addRoute('Layout', has);
            next({
              path: has.path
            });
          } else {//没有访问权限跳转到404页
            next('/404')
          }
        } else {
          let systemId = localStorage.getItem('SystemId');
          if(systemId){//已经选择系统继续
            //区分系统跳转主页
            if(systemId==1){
              next();
              NProgress.done()
            }else if(systemId==2){
              document.title = '智慧储能平台-蜂巢能源科技有限公司';
              if(to.name=='Home'){
                next({path:'/svolt'})
              }else{
                next();
              }
              NProgress.done()
            }

          }else{//未选择系统，如果进入的是非系统选择项则退出到登陆页，否则继续
            if(to.path!='/system'){
              removeToken();
              next({path:'/login'});
              NProgress.done()
            }else{
              next();
              NProgress.done()
            }
          }

        }
      } else {
        next()
        NProgress.done()
      }

      // if(store.getters.permission_routes.length === 0){
      //   const accessRoutes = await store.dispatch('permission/generateRoutes')
      //   router.addRoutes(accessRoutes)
      //   next({ path: to.path})
      // }else{
      //   next()
      // }

      // if (to.matched.length === 0) {
      //   next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
      // }

    }
  } else {
    console.log('没有登陆的白名单');
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
    NProgress.done()
  }
})



// WEBPACK FOOTER //
// ./src/utils/permission.js